import { TIconProps } from './utils';

export const ArrowLinkGradientIcon = ({ className = '' }: TIconProps) => (
  <svg
    width='7'
    height='11'
    viewBox='0 0 7 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M0.987285 10.3375C0.645259 9.98699 0.644954 9.42772 0.986598 9.07681L3.78981 6.19759C4.16781 5.80934 4.16781 5.19066 3.78981 4.80241L0.986598 1.92319C0.644954 1.57228 0.645259 1.01301 0.987285 0.662479C1.34168 0.299265 1.92568 0.299265 2.28008 0.662479L6.31876 4.80163C6.69777 5.19007 6.69777 5.80992 6.31876 6.19837L2.28008 10.3375C1.92568 10.7007 1.34168 10.7007 0.987285 10.3375Z'
      fill='url(#paint0_linear_3556_596)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3556_596'
        x1='-2.1706'
        y1='11.939'
        x2='4.04587'
        y2='-1.98925'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B36BFF' />
        <stop offset='1' stopColor='#5A75FF' />
      </linearGradient>
    </defs>
  </svg>
);
